import _reduce from 'lodash/reduce';
import _isEmpty from 'lodash/isEmpty';
import _forEach from 'lodash/forEach';
import _toFinite from 'lodash/toFinite';
import {
  LOGIN,
  SEND_CMD_DEVICE_SUCCESS,
  TRIGGER_INSTALLATION_SCENARIO_SUCCESS,
  TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_SUCCESS,
  SEND_DEVICE_SMS_SUCCESS,
  GET_INSTALLATION_SUCCESS,
  GET_INSTALLATION_SCENARIOS,
  GET_INSTALLATION_SCENARIOS_SUCCESS,
  GET_INSTALLATION_CUSTOMERS_LIST,
  GET_INSTALLATION_CUSTOMERS_LIST_SUCCESS,
  GET_INSTALLATION_PLANNINGS,
  GET_INSTALLATION_PLANNINGS_SUCCESS,
  // GET_INSTALLATION_ASYNC_OPERATIONS_LIST,
  GET_INSTALLATION_DEVICES_SUCCESS,
  GET_DEVICE_SUCCESS,
  CPM_GET_CARPARK_PLANNINGS,
  CPM_GET_CARPARK_PARKING_CATEGORIES,
  CPM_GET_CARPARK_PARKINGS_LIST,
  CPM_TRIGGER_CARPARK_DOOR,
} from '../constants/ActionTypes';
import {
  WS_TOPIC_DEVICE_SMS,
  ASYNC_OP_STATUS_PENDING,
} from '../constants/App';
import {
  getOperators,
  registerDeviceCmd, registerInstallationTrigger,
  wsJoinTopic,
  purgeAsyncOperations, registerAsyncOperation,
  cpmPurgeOperations, cpmRegisterCarparkTrigger,
} from '../actions';
// Models
import mAsync from '../models/async';
import mProduct from '../models/product';

// From product, get if operators are loaded
const { loadOperators } = mProduct.getConfig();

const apiServicePostProcess = (store) => (next) => (action) => {
  next(action);

  let resourceKey;
  let resources;
  let resource;
  let pendingResourceAsyncOperations;
  let mutationResult;

  switch (action.type) {
    case LOGIN:
      // After a successfull login, load operators (is needed)
      if (loadOperators) {
        store.dispatch(getOperators());
      }
      break;
    // ------------------------------ //
    // OPAC
    // ------------------------------ //
    case SEND_CMD_DEVICE_SUCCESS:
      if (store.getState().webSocket.open) {
        next(registerDeviceCmd(action.device, action.cmd, action.data.data.id));
      }
      break;
    case SEND_DEVICE_SMS_SUCCESS:
      if (store.getState().webSocket.open) {
        // Dispatch a new action to join SMS topic
        store.dispatch(wsJoinTopic(`${WS_TOPIC_DEVICE_SMS}:${action.data.data.id}`, action.data.data.id, { device_id: action.device.id }));
      }
      break;
    case TRIGGER_INSTALLATION_SCENARIO_SUCCESS:
      if (store.getState().webSocket.open) {
        resource = {
          ...action.scenario,
          type: 'scenario',
        };
        next(registerInstallationTrigger(resource, action.data.data.id));
      }
      break;
    case TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_SUCCESS:
      if (store.getState().webSocket.open) {
        resource = {
          ...action.right,
          type: 'right',
        };
        next(registerInstallationTrigger(resource, action.data.data.id));
      }
      break;
    case GET_INSTALLATION_SCENARIOS:
      if (!action.firstLoad) {
        next(purgeAsyncOperations('idScenario'));
      }
      break;
    case GET_INSTALLATION_CUSTOMERS_LIST:
      if (!action.firstLoad) {
        next(purgeAsyncOperations('idCustomer'));
      }
      break;
    case GET_INSTALLATION_PLANNINGS:
      if (!action.firstLoad) {
        next(purgeAsyncOperations('idPlanning'));
      }
      break;
    case GET_INSTALLATION_SUCCESS:
      // Get resource (=installation)
      resource = action.data.data;
      if (resource) {
        // Treat installation itself
        const { id, async_operation: installationAsyncOperation } = resource;
        if (installationAsyncOperation && installationAsyncOperation.status === ASYNC_OP_STATUS_PENDING) {
          // Now register async operation
          store.dispatch(registerAsyncOperation(mAsync.createAsyncOperation(installationAsyncOperation, { key: 'idInstallation', id })));
        }
        // Treat entities
        resources = resource.entities;
        // Parse entities to store their async operation in pending status
        pendingResourceAsyncOperations = _reduce(resources, (result, res) => {
          const { async_operation: asyncOperation } = res;
          if (asyncOperation && asyncOperation.status === ASYNC_OP_STATUS_PENDING) {
            result.push({
              resourceId: res.id,
              asyncOperation,
            });
          }
          return result;
        }, []);
        // Now parse these async operations to register them
        if (!_isEmpty(pendingResourceAsyncOperations)) {
          _forEach(pendingResourceAsyncOperations, (resourceAsyncOperation) => {
            const { resourceId, asyncOperation } = resourceAsyncOperation;
            store.dispatch(registerAsyncOperation(mAsync.createAsyncOperation(asyncOperation, { key: 'idEntity', id: resourceId })));
          });
        }
      }
      break;
    case GET_INSTALLATION_SCENARIOS_SUCCESS:
    case GET_INSTALLATION_CUSTOMERS_LIST_SUCCESS:
    case GET_INSTALLATION_PLANNINGS_SUCCESS:
      // Get resources from action
      resources = action.data.data;
      // Set key according to initial action
      if (action.type === GET_INSTALLATION_SCENARIOS_SUCCESS) {
        resourceKey = 'idScenario';
      } else if (action.type === GET_INSTALLATION_CUSTOMERS_LIST_SUCCESS) {
        resourceKey = 'idCustomer';
      } else if (action.type === GET_INSTALLATION_PLANNINGS_SUCCESS) {
        resourceKey = 'idPlanning';
      }
      // Parse resources to store their async operation in pending status
      pendingResourceAsyncOperations = _reduce(resources, (result, res) => {
        const { async_operation: asyncOperation } = res;
        if (asyncOperation && asyncOperation.status === ASYNC_OP_STATUS_PENDING) {
          result.push({
            resourceId: res.id,
            asyncOperation,
          });
        }
        return result;
      }, []);
      // Now parse these async operations to register them
      if (!_isEmpty(pendingResourceAsyncOperations)) {
        _forEach(pendingResourceAsyncOperations, (resourceAsyncOperation) => {
          const { resourceId, asyncOperation } = resourceAsyncOperation;
          store.dispatch(registerAsyncOperation(mAsync.createAsyncOperation(asyncOperation, { key: resourceKey, id: resourceId })));
        });
      }
      break;
    // case `${GET_INSTALLATION_ASYNC_OPERATIONS_LIST}_SUCCESS`:
    //   // Get resources (=async operations) from action
    //   resources = action.data.data;
    //   // Parse async operations to store the ones in pending status
    //   pendingResourceAsyncOperations = _reduce(resources, (result, asyncOperation) => {
    //     if (asyncOperation.status === ASYNC_OP_STATUS_PENDING) {
    //       result.push({
    //         resourceId: asyncOperation.resource_id,
    //         resourceKey: mInstallationAsyncOperation.resourceType(asyncOperation).resourceKey,
    //         asyncOperation,
    //       });
    //     }
    //     return result;
    //   }, []);
    //   // Now parse these async operations to register them
    //   if (!_isEmpty(pendingResourceAsyncOperations)) {
    //     _forEach(pendingResourceAsyncOperations, (resourceAsyncOperation) => {
    //       const { resourceId, asyncOperation } = resourceAsyncOperation;
    //       store.dispatch(registerAsyncOperation(mAsync.createAsyncOperation(asyncOperation, { key: resourceAsyncOperation.resourceKey, id: resourceId })));
    //     });
    //   }
    //   break;
    case GET_INSTALLATION_DEVICES_SUCCESS:
      // Get resources (=devices) from action
      resources = action.data.data;
      // Parse devices to store their config/slaves async operation in pending status
      pendingResourceAsyncOperations = _reduce(resources, (result, device) => {
        const { config, device_slaves: deviceSlaves } = device;
        // Treat config
        if (config) {
          const { async_operation: asyncOperation } = config;
          if (asyncOperation && asyncOperation.status === ASYNC_OP_STATUS_PENDING) {
            result.push({
              resourceKey: 'idConfig',
              resourceId: config.id,
              asyncOperation,
            });
          }
        }
        // Treat slaves
        if (!_isEmpty(deviceSlaves)) {
          _forEach(deviceSlaves, (slave) => {
            const { async_operation: asyncOperation } = slave;
            if (asyncOperation && asyncOperation.status === ASYNC_OP_STATUS_PENDING) {
              result.push({
                resourceKey: 'idSlave',
                resourceId: slave.id,
                asyncOperation,
              });
            }
          });
        }
        return result;
      }, []);
      // Now parse these async operations to register them
      if (!_isEmpty(pendingResourceAsyncOperations)) {
        _forEach(pendingResourceAsyncOperations, (resourceAsyncOperation) => {
          const { resourceKey, resourceId, asyncOperation } = resourceAsyncOperation; // eslint-disable-line no-shadow
          store.dispatch(registerAsyncOperation(mAsync.createAsyncOperation(asyncOperation, { key: resourceKey, id: resourceId })));
        });
      }
      break;
    case GET_DEVICE_SUCCESS:
      // Get resource (=device)
      resource = action.data.data;
      if (resource) {
        // Parse device to store its config/slaves async operation in pending status
        pendingResourceAsyncOperations = [];
        const { config, device_slaves: deviceSlaves } = resource;
        // Treat config
        if (config) {
          const { async_operation: asyncOperation } = config;
          if (asyncOperation && asyncOperation.status === ASYNC_OP_STATUS_PENDING) {
            pendingResourceAsyncOperations.push({
              resourceKey: 'idConfig',
              resourceId: config.id,
              asyncOperation,
            });
          }
        }
        // Treat slaves
        if (!_isEmpty(deviceSlaves)) {
          _forEach(deviceSlaves, (slave) => {
            const { async_operation: asyncOperation } = slave;
            if (asyncOperation && asyncOperation.status === ASYNC_OP_STATUS_PENDING) {
              pendingResourceAsyncOperations.push({
                resourceKey: 'idSlave',
                resourceId: slave.id,
                asyncOperation,
              });
            }
          });
        }
        // Now parse these async operations to register them
        if (!_isEmpty(pendingResourceAsyncOperations)) {
          _forEach(pendingResourceAsyncOperations, (resourceAsyncOperation) => {
            const { resourceKey, resourceId, asyncOperation } = resourceAsyncOperation; // eslint-disable-line no-shadow
            store.dispatch(registerAsyncOperation(mAsync.createAsyncOperation(asyncOperation, { key: resourceKey, id: resourceId })));
          });
        }
      }
      break;
    // ------------------------------ //
    // CPM
    // ------------------------------ //
    case CPM_GET_CARPARK_PLANNINGS:
      if (!action.firstLoad) {
        next(cpmPurgeOperations('idPlanning'));
      }
      break;
    case CPM_GET_CARPARK_PARKING_CATEGORIES:
      if (!action.firstLoad) {
        next(cpmPurgeOperations('idParkingCategory'));
      }
      break;
    case CPM_GET_CARPARK_PARKINGS_LIST:
      if (!action.firstLoad) {
        next(cpmPurgeOperations('idParking'));
      }
      break;
    case `${CPM_TRIGGER_CARPARK_DOOR}_SUCCESS`:
      if (store.getState().webSocket.open) {
        mutationResult = action.data.triggerDoor;
        resource = {
          ...action.door,
          type: 'door',
        };
        next(cpmRegisterCarparkTrigger(resource, _toFinite(mutationResult.operation.id)));
      }
      break;
    default:
      break;
  }
};

export default apiServicePostProcess;



// WEBPACK FOOTER //
// ./middlewares/apiServicePostProcess.js